/* jshint esversion: 6 */
import { filter, mergeMap } from 'rxjs/operators';
import api from 'app/redux/api.js';
import { UserActions } from 'app/redux/actions.js';
import * as constants from 'app/redux/constants.js';

export const fetchUserEpic = (action$, state$) => action$.pipe(
    filter(action => (action.type === constants.USER_FETCH && action.status === constants.STATE_TXRX)),
    mergeMap(action => api(action.type, state$, null, null, UserActions.receiveUser))
);

export const fetchUserPermsEpic = (action$, state$) => action$.pipe(
    filter(action => (action.type === constants.USER_FETCH_PERMS && action.status === constants.STATE_TXRX)),
    mergeMap(action => api(action.type, state$, null, null, UserActions.receivePerms))
);

export const fetchUserPlanEpic = (action$, state$) => action$.pipe(
    filter(action => (action.type === constants.USER_FETCH_PLAN && action.status === constants.STATE_TXRX)),
    mergeMap(action => api(action.type, state$, null, null, UserActions.receivePlan))
);

export const updateUserEpic = (action$, state$) => action$.pipe(
    filter(action => (action.type === constants.USER_UPDATE && action.status === constants.STATE_TXRX)),
    mergeMap(action => api(action.type, state$, null, action.post, UserActions.updatedUser))
);

export const deleteUserEpic = (action$, state$) => action$.pipe(
    filter(action => (action.type === constants.USER_DELETE && action.status === constants.STATE_TXRX)),
    mergeMap(action => api(action.type, state$, action.id, null, UserActions.deletedUser))
);

export const fetchAPIKeyEpic = (action$, state$) => action$.pipe(
    filter(action => (action.type === constants.USER_GENERATE_API_KEY && action.status === constants.STATE_TXRX)),
    mergeMap(action => api(action.type, state$, null, null, UserActions.receiveAPIKey))
);

export const detachClientEpic = (action$, state$) => action$.pipe(
    filter(action => (action.type === constants.USER_DETACH_CLIENT && action.status === constants.STATE_TXRX)),
    mergeMap(action => api(action.type, state$, null, null, UserActions.detachedClient))
);
